import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TrsssvComponent } from 'app/modules/equipment-registration/component/trsssv/trsssv.component';
import { WrsvComponent } from 'app/modules/equipment-registration/component/wrsv/wrsv.component';
import { module } from 'app/modules/equipment-registration/equipment-registration.module';
import { EquipRegistrationServices } from 'app/modules/equipment-registration/services/equipment-registration.service';

@Component({
  selector: 'app-wrsv-scssv',
  templateUrl: './wrsv-scssv.component.html',
  standalone: true,
  imports: [...module,
    TrsssvComponent,
    WrsvComponent],
  styleUrls: ['./wrsv-scssv.component.scss']
})
export class WrsvScssvComponent {
  public equipmentRegistration$ = this.equipmentServices.equipmentRegistration$
  public isReplace: boolean = true;
  public disabledToggle: boolean = true;
  public routes: string = '';

  constructor(
    private equipmentServices: EquipRegistrationServices,
    public router: Router,
  ) { }

  ngOnInit(): void {
    this.toggleTrsssv('trscssv')
  }

  toggleReplace() {
    this.equipmentServices.setReplace(this.isReplace);
  }

  toggleTrsssv(routes: any) {
    this.equipmentRegistration$.subscribe(wellEquipment => {
      if (!wellEquipment) return;

      if (routes == 'trscssv') {
        this.isReplace = !wellEquipment?.scssv;
        this.disabledToggle = !wellEquipment?.scssv;
      } else {
        this.isReplace = !wellEquipment?.wrsv;
        this.disabledToggle = !wellEquipment?.wrsv;
      }

      this.toggleReplace()
    })

    this.router.navigate([`/data-management/eReg/equipment-registration/trscssv-wrsv/${routes}`]);
  }

}
